<script setup lang="ts">
import { useRouteQuery } from '@vueuse/router/index'

const { t } = useI18n()

useSeoMeta({
  title: t('pages.designers.meta.title'),
  description: t('pages.index.meta.description'),
})

const itemsPerPage = ref(12)
const page = useRouteQuery('page', 1, { transform: Number })
const designersRepository = createDesignersRepository()

const { data: designers, status } = await useLazyAsyncData(
  () => designersRepository.getAllPagination(page.value, itemsPerPage.value),
  {
    watch: [page],
    default: defaultPaginationObject,
  }
)

const designersContent = ref<HTMLElement | null>()
watch(page, () => {
  designersContent.value?.scrollIntoView({ behavior: 'smooth' })
})
</script>

<template>
  <main>
    <UiBanner
      :title="$t('pages.designers.label')"
      :description="$t('designers.perex')"
    />
    <section ref="designersContent" class="pb-16">
      <div class="container">
        <div class="flex flex-wrap">
          <DesignersCard
            v-for="designer in designers.items"
            :key="designer.nid"
            :designer="designer"
          />
        </div>

        <div class="flex justify-end pr-6">
          <UiPagination
            v-model:value="page"
            :items-per-page="itemsPerPage"
            :item-count="designers.itemCount"
            :loading="status === 'pending'"
          />
        </div>
      </div>
    </section>
    <NewsSubscribe class="bg-neutral-50" />
  </main>
</template>
